<template>
    <div>
        <!-- <button @click="test">test</button> -->
        <!-- join class -->
        <div class="tutoring-item class-item-1" v-if="tutoring.status == 2 && this.user_info.student_type != 0">
            <div class="tutoring-item-left">
                <h4>{{tutoring.time_start | convertUnitToTime('ddd')}} - {{tutoring.time_start | convertUnitToTime('DD/MM/YYYY')}} - {{tutoring.time_start | convertUnitToTime('HH:mm')}} {{$t('to')}} {{tutoring.time_end | convertUnitToTime('HH:mm')}}
                    <template>
                        <span class="live-class-dot"></span><span class="live-class-text">{{$t('live_now_2')}}</span>
                    </template>                    
                </h4>
                <div class="d-flex justify-content-between">
                    <div class="">
                        <div class="desc"><b>{{$t('class')}}:  {{tutoring.class_name}} </b> </div>
                        <div class="desc"><b>{{$t('subject')}}:  {{tutoring.subject}} </b> </div>
                        <div class="desc"><b>{{$t('teacher')}}:  {{tutoring.teacher}} </b> </div>
                    </div>
                    <div class="tutoring-item-right">
                        <button class="btn-join" @click="btnJoinClass(tutoring.start_url)"><CountdownCloseClass :tutoring = "tutoring" :key="tutoring.id"/>{{$t('lisa_web_join_to_class')}}</button>
                    </div>  
                </div>
            </div>    
            
        </div>
        

        <!-- Comming -->
        <div class="tutoring-item tutoring-item-2 class-item-2" v-else-if="tutoring.status == 1">
            <div class="tutoring-item-left">
                <h4>{{tutoring.time_start | convertUnitToTime('ddd')}} - {{tutoring.time_start | convertUnitToTime('DD/MM/YYYY')}} - {{tutoring.time_start | convertUnitToTime('HH:mm')}} {{$t('to')}} {{tutoring.time_end | convertUnitToTime('HH:mm')}}
                    <template v-if="tutoring.is_live == 1">
                        <span class="live-class-dot"></span><span class="live-class-text">{{$t('live_now')}}</span>
                    </template>
                </h4>

                <div class="d-flex justify-content-between">
                    <div class="">
                        <div class="desc"><b>{{$t('class')}}:  {{tutoring.class_name}} </b></div>
                        <div class="desc"><b>{{$t('subject')}}:  {{tutoring.subject}} </b></div>
                        <div class="desc"><b>{{$t('teacher')}}: {{tutoring.teacher}}  </b></div>
                    </div>
                    <div class="tutoring-item-right">
                        <button class="btn-comming">{{$t('lisa_web_class_comming')}}<countdown style="margin-left:5px" :toturing = "tutoring" :key="tutoring.id"/></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Finish -->
        <div class="tutoring-item tutoring-item-3 class-item-3" v-else-if="tutoring.status == 4">
            <div class="tutoring-item-left">
                <h4>{{tutoring.time_start | convertUnitToTime('ddd')}} - {{tutoring.time_start | convertUnitToTime('DD/MM/YYYY')}} - {{tutoring.time_start | convertUnitToTime('HH:mm')}} {{$t('to')}} {{tutoring.time_end | convertUnitToTime('HH:mm')}}</h4>
                <div class="d-flex justify-content-between">
                    <div class="">
                        <div class="desc"><b>{{$t('class')}}: {{tutoring.class_name}} </b> </div>
                        <div class="desc"><b>{{$t('subject')}}: {{tutoring.subject}} </b> </div>
                        <div class="desc"><b>{{$t('teacher')}}: {{tutoring.teacher}} </b> </div>
                    </div>
                    <div class="tutoring-item-right">
                        <button class="btn-finish">{{$t('finished_classes_2')}}</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import {getTutorings, tutoringSubscribe } from "../../models/live_class";
import { joinClass } from "../../models/live_class";
import { convertSecondToText } from "../../utils/utils";
import Countdown from '../element/Countdown.vue';
import CountdownCloseClass from '../element/CoundownCloseClass.vue';


export default {
  components: { Countdown, CountdownCloseClass },
    name: "LiveClassItem",

    props: ['tutoring'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        }),
    },

    watch: {

    },

    data() {
        return {
            register_time_start: ""
        };
    },

    created() {
        this.countdown = this.tutoring.time_end;
    },

    methods: {
        btnJoinClass(url){
            window.open(url)                      
        },
        join_class(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            joinClass({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringDetailJoinClassModal'+tutoring.id).modal("hide");
                window.open(response.data.results.link, '_blank');
                that.$emit('updateTutoring', 'join_class', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        subscribe(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            tutoringSubscribe({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringRegisterModal' + tutoring.id).modal("hide");

                that.$emit('updateTutoring', 'subscribe', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        unsubscribeVerify(tutoring) {
            $('#tutoringDetailCancelRegistrationModal'+tutoring.id).modal('hide');
            $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal();
        },

        unsubscribe(tutoring) {
            const that = this;

            that.$store.commit("setLoading", true);

            tutoringSubscribe({
                id: tutoring.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#tutoringDetailCancelRegistrationVerifyModal'+tutoring.id).modal('hide');

                that.$emit('updateTutoring', 'unsubscribe', tutoring, response.data.results);
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },
        
        showDetailModal(tutoring){
            $('#tutoringDetailModal'+tutoring.id).modal('show');
        }
    }
}
</script>

<style scoped>
    .tutoring-item .tutoring-item-left h4{
        color: #00A3FF;
        font-weight: 700;
        font-size: 14px;
    }
    .tutoring-item .tutoring-item-left .desc{
        font-size: 12px;
        color: #000000;
    }
    .btn-finish{
        background: #C8C8C8;
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: 700;
        font-size: 14px;
        padding: 8px 20px;
        border: none;
        display: flex;
        height: 35px;
        align-items: center;
        white-space: nowrap;
        line-height: 35px;
    }
    .btn-comming{
        background: #40C0F6;
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: 700;
        font-size: 14px;
        padding: 8px 20px;
        border: none;
        height: 35px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        line-height: 35px;
        width: 200px;
    }
    .btn-join{
        background: #A2DF31;
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: 700;
        font-size: 14px;
        padding: 8px 20px;
        border: none;
        height: 35px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        line-height: 35px;
    }
    .tutoring-item-right{
        /* margin-right: 20px; */
        width: unset !important;
    }
    .live-class-dot{
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background: #FA450F;
        margin-left: 12px;
        margin-right: 4px;
    }
    .live-class-text{
        font-size: 12px;
        color: #FA450F;
        font-weight: 700;
    }
</style>
